import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { App } from './app/App';
import { SiteFailure } from './components/PageState';
import '@mastery/design-tokens/css';
import './styles.css';

const umamiWebsiteId = import.meta.env.VITE_UMAMI_WEBSITE_ID;
if (umamiWebsiteId && !document.querySelector('script[data-umami-tracker]')) {
  const script = document.createElement('script');
  script.async = true;
  script.defer = true;
  script.src = 'https://stats.weililiang1.com/script.js';
  script.dataset.websiteId = umamiWebsiteId;
  script.dataset.autoTrack = 'true';
  script.dataset.umamiTracker = 'true';
  document.head.appendChild(script);
}

const root = import.meta.hot?.data.root ?? createRoot(document.getElementById('root')!);
const router =
  import.meta.hot?.data.router ??
  createBrowserRouter([{ path: '*', element: <App />, errorElement: <SiteFailure /> }]);
if (import.meta.hot)
  import.meta.hot.dispose((data) => {
    data.root = root;
    data.router = router;
  });
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
